/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
// import { handlefetch } from "../CommonMethods/HandleComonData";

const user = localStorage.getItem('IdToken')
const initial = user ? true : false;
const initialState = {
    loading:false,
    error:'',
    common:{},
    isApiCalled:false,
    lastChangedParam:'',
    isAnimating:true,
}

  
// export const GetCommonData = createAsyncThunk('commondata', async (id) =>  handlefetch(id))

            
const CommonSlice = createSlice({

    name: 'CommonData',
    initialState,
    reducers: {
        handleDropDownValues:(state,action)=>{
            state=action.payload
        },
        handleGroup:(state,action)=>{
            state.CognitoGroup=action.payload
        },
        handleClear:(state,action)=>{
            state.loading=false;
            state.error='';
            state.common={};
            state.CognitoGroup=[];
            state.firstName='',
            state.lastName=''
        },
        handleIsAPICall:(state,action)=>{
            state.isApiCalled=action.payload
        },
        handleLastChangedParam:(state,action)=>{
            state.lastChangedParam=action.payload
        },
        handleSidebarAnimation:(state,action)=>{
            state.isAnimating=action.payload
        },
        
       
     
    

    },
    // extraReducers: {
    //     // register user
    //     [GetCommonData.pending]: (state) => {
    //         state.loading = true
    //         state.error = null
    //     },
    //     [GetCommonData.fulfilled]: (state, action) => {
    //         state.loading = false;
    //         state.common=action.payload
    //     },
    //     [GetCommonData.rejected]: (state, { payload }) => {
    //         state.loading = false
    //         state.error = payload?.message?.message
    //     },
    // },
})
export const {handleSidebarAnimation,handleLastChangedParam,handleDropDownValues,handleGroup,handleClear,handleIsAPICall } = CommonSlice.actions;
export default CommonSlice.reducer